module.exports = __webpack_public_path__ + "static/group15-e6e5cbd763145929dc1309e98da57f2e.png";